import React from 'react'

import { Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, number, shape, bool } from 'prop-types'

import slugify from 'Utils/slugify'

import formatDate from '../Utils/formatDate'

const imageProps = {
  loading: 'lazy',
  decoding: 'async',
}

function Reply({ reply, isLoggedIn = false }) {
  function renderWithOptionalLink(element) {
    if (isLoggedIn) {
      return (
        <a
          href={`/designers/${slugify(reply.username)}`}
          className="rating__profile-link"
        >
          {element}
        </a>
      )
    }
    return element
  }

  return (
    <div className="rating__reply">
      <div className="rating__reply-wrapper">
        {renderWithOptionalLink(
          <Avatar
            size="40"
            img={reply.avatar?.small?.url}
            username={reply.username}
            imageProps={imageProps}
          />
        )}
        <div className="rating__info-container">
          <div className="rating__reply-meta">
            <a
              href={`/designers/${slugify(reply.username)}`}
              className="rating__username"
            >
              {reply.username}
            </a>
            <span className="rating__date">{formatDate(reply.updatedAt)}</span>
          </div>
          <span className="rating__content">
            {reply.content}
          </span>
        </div>
      </div>
    </div>
  )
}

Reply.propTypes = {
  reply: shape({
    id: number.isRequired,
    userId: number,
    content: string.isRequired,
    updatedAt: string.isRequired,
    username: string.isRequired,
    avatar: shape({
      small: shape({
        url: string,
      }),
    }),
  }).isRequired,
  isLoggedIn: bool,
}

export default Reply
